import AccountAccessPage from "./AccountAccessPage";
import CustomerAccountPage from "../../client/account/CustomerAccountPage";

const AccountAccessConfig = {
    settings: { layout: { config: { navbar: { display: false }, toolbar: { display: false }, footer: { display: false } } } },
    routes: [
        { path: "account-access", auth: null, element: <AccountAccessPage /> },
        { path: "client/account", auth: ["customer", "paidcustomer"], element: <CustomerAccountPage /> }
    ]
};
export default AccountAccessConfig;
